/* Set your chart color scale here */

import { scaleOrdinal } from "d3-scale";

// COLORS
const lightGray = "#E5E2E0";
const blue = "#a2f6e8";
const lightBlue = "#d1faf3";
const lightOrange = "#ffe0cc"
const lighterGray = "rgba(229, 226, 224, 0.58)"
const fontGray = "#4a4a4a"
const fontLightGray = "rgb(167, 167, 167)"

const yes = "#A1DBF4"
const yesSub = "#D9ECF4"
const no = "#FFD4BF"
const na = lightGray

export const domain = ["Yes", "Yes - partial", "No","N/A"]

export const colorFillScale = scaleOrdinal()
  .domain(domain)
  .range([yes, yesSub, no, na])
  .unknown(lightGray);

export const colorTextScale = scaleOrdinal()
  .domain(domain)
  .range([fontGray])
  .unknown(fontGray)

// HIGH SATURATION - DEEP RED, BLUE
// const yes = "#33658A"
// const yesSub = "#1393D8"
// const no = "#f86705"
// const na = "rgb(169, 169, 169)"
// export const colorTextScale = scaleOrdinal()
//   .domain(domain)
//   .range(['white'])
//   .unknown('white')